import React from 'react';
import { cn } from '@restworld/utils-common';

export const StyledForm = ({ className, ...props }: React.FormHTMLAttributes<HTMLFormElement>) => (
  <form className={cn('h-full flex flex-col justify-between min-h-[510px]', className)} {...props} />
);
// div (not p): on the permission-level step this wraps a block subtitle (<div> with two <p>s), and a
// <p> containing a <div>/<p> is invalid HTML — the browser auto-closes the <p>, causing a hydration
// mismatch. div holds both the inline <span> (fill-info step) and the block content correctly.
export const ContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('text-neutral-200 mt-5 mb-12 font-medium', className)} {...props} />
);
export const ContentAndInputsWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('mb-10', className)} {...props} />
);
export const InputsWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('', className)} {...props} />
);
export const InputWrapper = ({
  isHidden,
  className,
  ...props
}: { isHidden?: boolean } & React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-2', isHidden && 'hidden', className)} {...props} />
);
export const StyledLabel = ({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) => (
  <label
    className={cn('text-start font-medium text-neutral-700 text-base w-full inline-block pl-1', className)}
    {...props}
  />
);
export const InputAndLabelWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('mb-4 md:mb-0 text-start', className)} {...props} />
);
export const InputsGridWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('grid grid-cols-1 md:grid-cols-2 md:gap-6', className)} {...props} />
);
export const ButtonsWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex gap-3 justify-center items-center', className)} {...props} />
);
export const FooterButtonsWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      // justify-between so the two CTAs sit at the modal's edges on desktop (like master); on mobile
      // the buttons are flex-1 (full-width, side by side) so justify has no visible effect there.
      'flex flex-row gap-3 w-full justify-between py-4 px-8 [&>button]:flex-1 [&>button]:md:flex-none',
      className
    )}
    {...props}
  />
);
